import React, { useCallback, useMemo } from 'react'

import { bool, func, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'
import JoinProgramModal from 'Pods/Shared/JoinProgramModal/JoinProgramModal'

import { NOOP } from 'Utils/stableDefaults'

import InfoCard from './InfoCard'
import JoinProgramCard from './JoinProgramCard'
import useJoinProgram from '../../Hooks/useJoinProgram'

function StatusCard({ isParticipating = false, locale = 'en', onJoinSuccess = NOOP }) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )

  const messages = useMemo(() => ({
    success: translate('my_subscriptions.join_modal.success'),
    error: translate('my_subscriptions.join_modal.error'),
  }), [translate])

  const {
    isModalOpen,
    isJoining,
    handleOpenModal,
    handleCloseModal,
    handleJoinProgram,
  } = useJoinProgram({ messages, onSuccess: onJoinSuccess })

  return (
    <div className="status-card">
      <div className="status-card__info-card">
        <div className="status-card__container">
          <InfoCard isParticipating={isParticipating} translate={translate} />
          {!isParticipating && (
            <JoinProgramCard translate={translate} onJoinProgram={handleOpenModal} />
          )}
        </div>
      </div>
      <JoinProgramModal
        isOpen={isModalOpen}
        isJoining={isJoining}
        onClose={handleCloseModal}
        onConfirm={handleJoinProgram}
        translate={translate}
      />
    </div>
  )
}

StatusCard.propTypes = {
  isParticipating: bool,
  locale: string,
  onJoinSuccess: func,
}

export default StatusCard
